module.exports = __webpack_public_path__ + "static/media/seeds.d1f0357b.jpg";